import {useNavigate} from "react-router";
import {saveCampaign} from "@/api/CampaignApi.ts";
import Campaign from "@/campaigns/model/Campaign.ts";
import CampaignForm from "@/admin/campaigns/form/CampaignForm.tsx";
import type {SaveCampaignRequest} from "@/api/CampaignApi.ts";

export default function CampaignCreateView() {
    const navigate = useNavigate();
    const onSubmit = async (request: SaveCampaignRequest): Promise<Campaign> => {
        const saved = await saveCampaign(request);
        navigate(`/admin/campaigns/${saved.slug}`, {replace: true});
        return saved;
    };
    return <><title>Neue Kampagne | DireDawn</title><CampaignForm onSubmit={onSubmit}/></>;
}
